import { Bar, Line } from "react-chartjs-2";
import React, { useEffect, useState } from "react";

import ChartAnnotations from "chartjs-plugin-annotation";
import PropTypes from "prop-types";
import moment from "moment";

const LineChartOffshore = props => {
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == "string") {
      if (number.includes("+")) {
        return (
          "+ " +
          parseFloat(number.replaceAll("+", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
      if (number.includes("-")) {
        return (
          "- " +
          parseFloat(number.replaceAll("-", "").trim())
            .toFixed(digit)
            .toLocaleString(undefined, {
              minimumFractionDigits: digit,
            })
        );
      }
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const [min, setMin] = useState(null)
  const [max, setMax] = useState(null)
  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        label: "Balancing",
        backgroundColor: "#F1AF4E",//437AD5
        borderColor: "#F1AF4E", //437AD5
        borderWidth: 3,
        pointBorderWidth: 2,
        hoverBorderWidth: 5,
        hoverBackgroundColor: "#F1AF4E", //437AD5
        hoverBorderColor: "#FFFFFF",
        data: [],
        type: "line",
        showLine: true,
        pointStyle: "dot",
        // pointRadius: 2,
        fill: false,
        tension: 0,
        datalabels: {
          font: {
            weight: 'bold',
            size: 14,
          }
        },
      },
    ],
  });
  const target = 5;
  const [option, setOption] = useState({
    maintainAspectRatio: false,
    scales: {
      dataset: [
        {
          barPercentage: 0.4,
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            fontSize: 13,
            labelString: "Date",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 13,
          },
        },
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            fontSize: 13,
            labelString: "Percent (%)",
            fontColor: "#FFFFFF",
            fontStyle: "bold",
          },
          gridLines: {
            display: true,
          },
          ticks: {
            stepSize: 10,
            fontColor: "#FFFFFF",
            fontStyle: "bold",
            fontSize: 13,
            callback: function (label, index, labels) {
              var val = Math.abs(label);
              // if (val >= 1000) {
              //   if (label < 0) {
              //     val = val * -1;
              //   }
              //   val = numberFormat(val/1000, 1) + " K";
              // } else {
              if (label < 0) {
                val = val * -1;
              }
              val = numberFormat(val, 0);
              // }

              return val;
            },

          },
        },
      ],
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      intersect: false,
      titleFontSize: 20,
      bodyFontSize: 18,
      bodyFontStyle: "bold",
      callbacks: {
        label: function (tooltipItem, data) {
          // console.log(tooltipItem);
          // console.log(data);
          // var indice = tooltipItem.index;
          return "  " + numberFormat(tooltipItem.yLabel, 1) + " %";
        }
      },
    },
    legend: {
      display: false,
      labels: {
        fontColor: "#FFFFFF",
        fontStyle: "bold",
        fontSize: 13,
        filter: item => {
          if (item.text != "MAX" && item.text != "MIN") {
            return true;
          }
        },
      },
    },
    annotation: {
      annotations: [
        // {
        //   type: "line",
        //   mode: "horizontal",
        //   scaleID: "y-axis-0",
        //   value: target,
        //   borderColor: "red",
        //   borderWidth: 0.7,
        //   borderDash: [10, 5],
        //   // borderDashOffset: 5,
        //   label: {
        //     backgroundColor: "rgba(0,0,0,0)",
        //     fontSize: 12,
        //     fontStyle: "bold",
        //     fontColor: "rgba(255, 0, 0, 0.6)",
        //     position: "right",
        //     enabled: true,
        //     content: "Max",
        //     yAdjust: 10,
        //   },
        // },
        // {
        //   type: "line",
        //   mode: "horizontal",
        //   scaleID: "y-axis-0",
        //   value: -target,
        //   borderColor: "red",
        //   borderWidth: 0.7,
        //   borderDash: [10, 5],
        //   label: {
        //     backgroundColor: "rgba(0,0,0,0)",
        //     fontSize: 12,
        //     fontStyle: "bold",
        //     fontColor: "rgba(255, 0, 0, 0.6)",
        //     position: "right",
        //     enabled: true,
        //     content: "Min",
        //     yAdjust: 10,
        //   },
        // }
      ],
    },
  })
  useEffect(() => {



    let dataSort = props.balancingGraphData
      .sort(function (a, b) {
        return moment(a.REPORT_DATE).toDate() - moment(b.REPORT_DATE).toDate();
      })
    // .slice(Math.max(props.balancingGraphData.length - 15, 1));

    let dateList = [moment(props.date).locale("en").format("D MMM")];

    for (let index = 0; index < 14; index++) {

      dateList.unshift(
        moment(props.date)
          .add("days", -(index + 1))
          .locale("en")
          .format("D MMM")
      );

    }
    let dataGraph = []
    dateList.map(item => {
      let data = dataSort.find(row => {
        if (item == moment(props.date).locale("en").format("D MMM")) {
          return (
            moment(row.REPORT_DATE).locale("en").format("D MMM") == item &&
            props.summaryReportPid == row.SUMMARYREPORT_PID
          );
        }
        return (
          moment(row.REPORT_DATE).locale("en").format("D MMM") == item
        );
      });
      dataGraph.push(data?.BALANCING_BALANCE);
    });
    // console.log(dataSort,dataSort.map(row=>moment(row.REPORT_DATE).locale("en").format("D MMM YYYY")))
    setData(prev => ({
      ...prev,
      labels: dateList,
      datasets: [{ ...prev.datasets[0], data: dataGraph }],
    }));

    // console.log(dataGraph)
  }, [props.balancingGraphData]);
  return (
    <React.Fragment>
      <Line data={data} options={option} />
    </React.Fragment>
  );
};
LineChartOffshore.propTypes = {
  t: PropTypes.any,

  balancingGraphData: PropTypes.any,
  minMax: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default LineChartOffshore;
